import { Routes } from '@angular/router';
import {LayoutComponent} from './layouts/layout.component';
import {HealthComponent} from './health/health.component';
import {EmbedShellComponent} from './embed/embed-shell.component';

export const routes: Routes = [
  {
    path: 'registration/landing',
    component: EmbedShellComponent,
  },
  {
    path: "",
    component: LayoutComponent,
    loadChildren: () =>
      import("./pages/pages.module").then((m) => m.PagesModule),
    canActivate: [],
  },
  {
    path: 'health',   // <-- remove the leading slash
    component: HealthComponent,
    canActivate: [],
  },
  // optionally, otherwise redirect to a not-found:
  // { path: '**', redirectTo: '' }
];
